import { ListItem } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Colors from '../../../layout/theme/utils/colors';

const styles = () => ({
  root: {
    '&:hover': {
      backgroundColor: Colors.sky_blue,
    },
  },
});

export const StyledListItem = withStyles(styles)(ListItem);
